export enum ProfileScreenEnum {
  Viewing,
  Editing,
}
